import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const itineraryMapMarkerEntity: Entity = {
  model: model,
  repository: repository,
}

export default itineraryMapMarkerEntity
